import { EndorsementType } from './EndorsementType';

export class Endorsement {
  constructor(public readonly id: string, public readonly value: string, public readonly type: EndorsementType) {
  }
}
